import styles from "@css/modules/PointChart.module.scss"
import cn from "classnames"
import { useEffect } from "react"

export const cellTypeClasses = {
    1: styles.cellType1,
    2: styles.cellType2,
    3: styles.cellType3,
    4: styles.cellType4,
    5: styles.cellType5
}

const numberFormat = new Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 1 })

export function getCellData(cell, key, points, pointsOrDays) {
    const { column, points_1, points_2, points_3, points_4, points_5 } = cell
    const percent = points && points * 0.2
    const getValue = (i) => {
        if (!pointsOrDays && points) {
            const val = points / i
            return numberFormat.format(val)
        }
        return i
    }
    const getClass = (i, k) => {
        return cn({
            [cellTypeClasses[k]]: true,
            [styles.pointsInactive]: points && points < i,
            [styles.pointsBold]: i + percent >= points && i <= points
        })
    }
    return (
        <span className={styles.cellGroup} key={key + "_" + column}>
            {points_1 && <span className={getClass(points_1, 1)}>{getValue(points_1)}</span>}
            {points_2 && <span className={getClass(points_2, 2)}>{getValue(points_2)}</span>}
            {points_3 && <span className={getClass(points_3, 3)}>{getValue(points_3)}</span>}
            {points_4 && <span className={getClass(points_4, 4)}>{getValue(points_4)}</span>}
            {points_5 && <span className={getClass(points_5, 5)}>{getValue(points_5)}</span>}
        </span>
    )
}

export function getColumns(chart) {
    if (!chart) return []
    const configs = chart.column_description
    return chart.headers.map((i, key) => {
        let children
        if (i.points_1 || i.points_2 || i.points_3 || i.points_4 || i.points_5) {
            children = []
        }
        for (let j = 1; j < 6; j++) {
            const key = "points_" + j
            const keyDesk = `points_${j}_desc`
            if (i[key]) {
                children.push({
                    key: j,
                    short: configs[key],
                    long: configs[keyDesk]
                })
            }
        }
        return {
            title: i.title,
            sub_title: i.sub_title,
            children,
            key
        }
    })
}

export const nightNames = {
    SUN_SAT: "Sun - Sat",
    SUN_THU: "Sun - Thu",
    FRI_SAT: "Fri - Sat",
    WEEKLY: "Weekly"
}

export const useSticky = (ref, mobile) => {
    useEffect(() => {
        if (mobile) {
            return
        }
        const onScroll = () => {
            if (!ref.current) return
            const target = ref.current
            const rect = ref.current.parentElement.getBoundingClientRect()
            const diff = rect.bottom + window.scrollY - (window.scrollY + window.innerHeight)
            if (target) {
                if (diff > 0) {
                    target.style.transform = `translateY(${-diff}px)`
                } else {
                    target.style.transform = `translateY(0px)`
                }
            }
        }
        window.addEventListener("scroll", onScroll, { passive: true })
        window.addEventListener("resize", onScroll, { passive: true })
        return () => {
            window.removeEventListener("scroll", onScroll)
            window.removeEventListener("resize", onScroll)
        }
    }, [ref, mobile])
}

export const useStickyHeader = () => {
    useEffect(() => {
        const parent = document.querySelector("." + styles.table)
        const target = parent.querySelector("thead")
        const target2 = document.querySelector("." + styles.leftTable + " thead")
        const onScroll = () => {
            if (!parent) return
            const rect = parent.getBoundingClientRect()
            const diff = rect.top - 58
            if (target) {
                const max = Math.max(diff, -(rect.height - target.offsetHeight))
                if (diff < 0) {
                    target.style.transform = `translateY(${-max}px)`
                    target2.style.transform = `translateY(${-max}px)`
                } else {
                    target.style.transform = `translateY(0px)`
                    target2.style.transform = `translateY(0px)`
                }
            }
        }
        window.addEventListener("scroll", onScroll, { passive: true })
        window.addEventListener("resize", onScroll, { passive: true })
        return () => {
            window.removeEventListener("scroll", onScroll)
            window.removeEventListener("resize", onScroll)
        }
    }, [])
}
